import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SpinnerModule } from '@spartacus/storefront'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { EbSpinnerModule } from '../spinner/eb-spinner.module'
import { EbGenericScrollComponent } from './eb-generic-scroll.component'

@NgModule({
  imports: [CommonModule, InfiniteScrollModule, SpinnerModule, EbSpinnerModule],
  declarations: [EbGenericScrollComponent],
  exports: [EbGenericScrollComponent]
})
export class EbGenericScrollModule {}
